export default __webpack_public_path__ + "static/media/leaf.4c15d6eb.png";